import React, { useEffect, useState } from 'react'
import useGoogleMapPlacesApiInit from '../useGoogleMap';
// import { GOOGLE_MAPS_API } from '../../../const/google';
import FormWizardButtons from '../../../yoello-lib/modules/dynamicForms/FormWizardButtons';
import EColourPanel from '../../../interfaces/EColourPanel';
import { ICallAPIFunction } from '../../../yoello-lib/modules/API2/types';
import { HTTPMethods } from '../../../services/API';
import { useSelector } from 'react-redux';
import { IReduxAppState } from '../../../reducers';
import { getDistanceBetweenTwoLocations } from '../../../yoello-lib/modules/utils/getDistanceBetweenTwoLocations';
import { useSnackbarMessages } from '../../../yoello-lib/modules/components/snackbar/SnackbarContext';
import { useTranslation } from 'react-i18next';

interface ISelectLocationOnMapProps{
  address_number?:string,
  address_street:string,
  address_city:string,
  address_postcode:string
  latitude?: number
  longitude?: number
  locationCallApi:ICallAPIFunction<any>
  idid: string;
  closeAll: () => void
}

export default function SelectLocationOnMap(props: ISelectLocationOnMapProps) {
  const {address_city, address_postcode, address_street, address_number} = props
  const {locationCallApi, idid, closeAll, latitude, longitude, ...rest} = props

  const [firstSubmit, setFirstSubmit] = useState(true)

  const { sendSnackbarMessage } = useSnackbarMessages()!;
  const { t } = useTranslation();

  const selectedVenueId = useSelector(
    (state: IReduxAppState) => state.selectedVenueId
  );

  const [originalLocation, setOriginalLocation] = useState<{lng: number, lat: number}>({
    lat: 0,
    lng: 0
  });

  const {initMap,getMarkerLocation} = useGoogleMapPlacesApiInit();

  useEffect(() => {
    // loadGoogleMapsScript();
    
    initMap({
      apartment: address_number,
      street_address: address_street,
      city: address_city,
      postcode: address_postcode,
    }, setOriginalLocation as any,()=> sendSnackbarMessage(t("selectLocation.locationNotFound"), "error"));
    // eslint-disable-next-line
  }, [props])

  async function onClickSubmit() {
    const userLocation = getMarkerLocation() as {lng: number, lat: number};

    if(getDistanceBetweenTwoLocations(originalLocation,userLocation) > 0.1 && firstSubmit ){
      sendSnackbarMessage(t("selectLocation.pinFarFromAddress"), "error")
      setFirstSubmit(false)
      return
    }

    try {
      await locationCallApi(HTTPMethods.PATCH, {
        body: {
          latitude: getMarkerLocation().lat,
          longitude: getMarkerLocation().lng,
          ...rest
        },
        query: `${selectedVenueId}/locations/${idid}`
      })
      sendSnackbarMessage(t("selectLocation.locationSuccessfullySet"), 'success');
      locationCallApi(HTTPMethods.GET)
      closeAll?.()
    } catch (error) {
      
    }
  }

  return (
    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', paddingRight: '2%', paddingLeft: '2%'}}>
      <div id='map' style={{width: '48vw', height: '48vh'}}  />
      <FormWizardButtons
        rightButton={{
          onClick: onClickSubmit,
          color: EColourPanel.PRIMARY,
          label: 'submit',
          type: 'submit',
          style: {width: '40vw',flex: 1, marginTop: '5vh', marginRight: 'auto', marginLeft: 'auto'}
        }}
      />
    </div>
  )
}
